module.exports = __webpack_public_path__ + "assets/logo-j.a14b1053.svg";